import React from 'react';
import { Row as Box } from './styles';
export const Row = ({ alignItems, justifyContent, nowrap, children, }) => {
    return (React.createElement(Box, { alignItems: alignItems, justifyContent: justifyContent, nowrap: nowrap }, children));
};
